const _sm = "600px"
const _md = "1020px"
const _lg = "1272px"
const _xl = "1512px"
const _2xl = "1920px"
const config = { "sm": _sm, "md": _md, "lg": _lg, "xl": _xl, "2xl": _2xl,  }
export { config as default, _sm, _md, _lg, _xl, _2xl }